import {useConsumerMenu} from "../context/MenuContext";
import {IconHome} from "@bounce/shared/consumer/bounce-ui";
import {useNavigate} from "react-router-dom";
import {urls} from "~/routes/consumerUrls";
import {useAuth} from "@bounce/shared/contexts";
import {useLoginDestinationUrl} from "~/contexts";
import {BounceRole} from "@bounce/shared/consumer/declarations";
import {clearNoLoginDialogFlags} from "~/constants/no-login-keys";
import {isPreLoginRole} from "~/helpers/roles";
import {CustomMenuItem, MenuItemDivider} from "@bounce/shared/consumer/components";
import React from "react";

const HomeMenuItem = () => {
  const {trackAndCloseMenu} = useConsumerMenu();
  const {loggedIn, userRole} = useAuth();
  const {clearDestinationUrl} = useLoginDestinationUrl();
  const navigate = useNavigate();

  if (!loggedIn && !isPreLoginRole(userRole)) return null;

  const onHomeClickButton = () => {
    trackAndCloseMenu("home");
    if (userRole === BounceRole.NO_LOGIN_USER) {
      clearNoLoginDialogFlags();
      clearDestinationUrl();
    }
    navigate(urls.accounts.url);
  };

  return (
    <>
      <CustomMenuItem onClick={onHomeClickButton} label="Home" icon={<IconHome width={20} height={20} />} />
      <MenuItemDivider />
    </>
  );
};

export default HomeMenuItem;
